import { useHistory } from "react-router-dom"
import { useVariablesAuthority } from "../useVariablesAuthority"
import { useApi } from "../useApi"

export const useVariables = () => {
  const { push } = useHistory()

  const { isCommonRefer, isHiddenReset, isHiddenSubmit } =
    useVariablesAuthority()

  const {
    callApi,
    form,
    isLoadingLayout,
    setIsLoadingLayout,
    timeFormatItems,
    timeZoneItems,
  } = useApi()

  return {
    callApi,
    form,
    isCommonRefer,
    isHiddenReset,
    isHiddenSubmit,
    isLoadingLayout,
    push,
    setIsLoadingLayout,
    timeFormatItems,
    timeZoneItems,
  }
}
